import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'lp-favorite-products-header',
  templateUrl: './lp-favorite-products-header.component.html',
  styleUrls: ['./lp-favorite-products-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpFavoriteProductsHeaderComponent extends BaseResizableComponent {
  @Input() title?: string;
}
